"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganizationList = void 0;
var shared_1 = require("@clerk/shared");
Object.defineProperty(exports, "useOrganizationList", { enumerable: true, get: function () { return shared_1.useOrganizationList; } });
